// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  padding: 1rem;
}

.modal-content {
  background-color: #ffffffbe;
  backdrop-filter: blur(8px);
  margin: auto;
  padding: 20px;
  border: 1px solid #8084ff;
  width: 100%;
  max-width: 800px;
  border-radius: 12px;
  max-height: 95vh;
  overflow-y: auto;
}

.close {
  color: red;
  float: right;
  font-size: 28px;
  font-weight: bold;
  background-color: rgba(255, 0, 0, 0.127);
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 1px solid rgba(255, 0, 0, 0.205);
}

.close:hover,
.close:focus {
  color: rgb(255, 255, 255);
  text-decoration: none;
  cursor: pointer;
  background-color: rgba(255, 0, 0, 0.573);
}

.form-group {
  width: 100%;
  margin-bottom: 12px;
}

.form-sub-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-flex-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
  border: 1px solid #6e73ff63;
  border-radius: 8px;
  height: 40px;
  background-color: white;
}

.submit-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}

.submit-button {
  background-color: #8084ff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
  height: 45px;
}

.submit-button:hover {
  background-color: #6e72ff;
}

@media (min-width: 640px) {
  .form-group {
    margin-bottom: 12px;
  }

  .form-sub-group {
    flex-direction: row;
  }

  .form-flex-box {
    flex-direction: row;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Modals/Modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF","sourcesContent":[".modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 99999;\n  padding: 1rem;\n}\n\n.modal-content {\n  background-color: #ffffffbe;\n  backdrop-filter: blur(8px);\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #8084ff;\n  width: 100%;\n  max-width: 800px;\n  border-radius: 12px;\n  max-height: 95vh;\n  overflow-y: auto;\n}\n\n.close {\n  color: red;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n  background-color: rgba(255, 0, 0, 0.127);\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  border: 1px solid rgba(255, 0, 0, 0.205);\n}\n\n.close:hover,\n.close:focus {\n  color: rgb(255, 255, 255);\n  text-decoration: none;\n  cursor: pointer;\n  background-color: rgba(255, 0, 0, 0.573);\n}\n\n.form-group {\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.form-sub-group {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-flex-box {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #6e73ff63;\n  border-radius: 8px;\n  height: 40px;\n  background-color: white;\n}\n\n.submit-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.submit-button {\n  background-color: #8084ff;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  width: 100%;\n  height: 45px;\n}\n\n.submit-button:hover {\n  background-color: #6e72ff;\n}\n\n@media (min-width: 640px) {\n  .form-group {\n    margin-bottom: 12px;\n  }\n\n  .form-sub-group {\n    flex-direction: row;\n  }\n\n  .form-flex-box {\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
